<template>
  <div 
    :class="{ 'SideBar--slim': slim }"
    class="SideBar">
    <template>
      <template v-if="hasBuurtChoice">
        <h5 class="SideBar__neighborhoodHeader pl-3 pr-4 mb-0 py-3 bg-gray-muted">
          <span class="ml-3">1:</span>
          De Buurt
          <FontAwesomeIcon :icon="['fas', 'info-circle']" :content="buurtTooltip" v-tippy="{ placement : 'right', interactive : true, delay: [0, 400] }" />
        </h5>
        <NeighborhoodControl class="SideBar__neighborhood mt-4" />
      </template>

      <template v-if="hasFilterControls">
        <h5 class="SideBar__filtersHeader pl-3 pr-4 mb-0 py-3 bg-gray-muted" @click="handleToggle({ section: 'filtering' })">
          <span class="ml-3">2:</span> 
          Barcode Selectie 
          <FontAwesomeIcon v-if="hasLegend" :icon="['fal', filteringOpen ? 'chevron-up' : 'chevron-down' ]" />
          <FontAwesomeIcon :icon="['fas', 'info-circle']" :content="filtersTooltip" v-tippy="{ placement : 'right', interactive : true, delay: [0, 400] }" /> 
        </h5> 
        <FilterControl 
          v-if="selectedFilter" 
          ref="filterControl"
          class="SideBar__filters"
          :last="true"
          :filter="selectedFilter"
          :class="{ 'SideBar__FilterControl--closed': (! filteringOpen) && hasLegend }"
          @close="handleClearSelectedFilter" />
        <FilterStatus 
          v-else
          ref="filterStatus"
          class="SideBar__filters" 
          :class="{ 'SideBar__Filters--closed': (! filteringOpen) && hasLegend }"
          @select="handleSelectedFilter" />
      </template>
      <template v-if="hasLegend">
        <h5 class="SideBar__legendHeader pl-3 pr-4 mb-0 py-3 bg-gray-muted" @click="handleToggle({ section: 'legend' })">
          <span class="ml-3">3:</span>
          De Weergave
          <FontAwesomeIcon :icon="['fal', legendOpen ? 'chevron-up' : 'chevron-down' ]" />
          <FontAwesomeIcon :icon="['fas', 'info-circle']" :content="weergaveTooltip" v-tippy="{ placement : 'right', interactive : true, delay: [0, 400] }" />
        </h5> 
        <Legend  
          class="SideBar__legend"
          :class="{ 'SideBar__legend--closed' : ! legendOpen }"
          v-if="!slim" />
      </template>

      <template v-if="hasIntroduction">
        <h5 class="pl-3 pr-4 mb-0 py-3 bg-gray-muted">
          <span class="ml-3"></span>
          Inhoud
        </h5>
        <ul class="mt-4 mx-3 px-3">
          <li>1. <a href="#intro">Slim &amp; Snel</a></li>
          <li>2. <a href="#barcodes">Uitleg over barcodes</a></li>
          <li>3. <a href="#uitleg">Uitleg over de applicatie</a></li>  
        </ul>
        <h5 class="pl-3 pr-4 mb-0 py-3 bg-gray-muted">
          <span class="ml-3"></span>
          Snel van start
        </h5>
        <p class="mx-3 px-3 mt-4">
          Meteen aan de slag? Begin met de data selectie, of ga meteen naar de kaart.
        </p>
        <div class="mx-3 px-3 w-100">
          <b-button :to="{ name: 'filters' }" class="mb-3">
            <FontAwesomeIcon size="lg" class="mr-2" :icon="['fal', 'barcode-alt' ]" />
            Naar de Barcode Selectie
          </b-button>
          <b-button :to="{ name: 'home' }">
            <FontAwesomeIcon size="lg" class="mr-2" :icon="['fal', 'map' ]" />
            Naar de kaart
          </b-button>
        </div>
      </template>
      <template v-if="hasBarcodeInstructions">
        <h5 class="pl-3 pr-4 mb-0 py-3 bg-gray-muted">
          <span class="ml-3">2:</span>
          Barcode Selectie
        </h5>
        <p class="mx-3 px-3 mt-4">
          Selecteer hiernaast de barcodes. In de kaart weergave kun je ook nog aanpassingen maken.
        </p>
        <h5 class="pl-3 pr-4 mb-0 py-3 bg-gray-muted">
          <span class="ml-3">3:</span>
          De Weergave
        </h5>
        <div>
          <p class="mx-3 px-3 mt-4">
            Klaar met de selectie?
          </p>
          <div class="mx-3 px-3 w-100">
            <b-button :to="{ name: 'home' }">
              <FontAwesomeIcon size="lg" class="mr-2" :icon="['fal', 'map' ]" />
              Naar de kaart
            </b-button>
          </div>
        </div>
      </template>

      <div class="SideBar__flex"></div>

      <div
        v-if="version && !slim"
        class="SideBar__version">
        Versie: {{ version }} 
        - 
        <router-link 
          class="text-muted" 
          :to="{ name: 'logout' }">
          Uitloggen
        </router-link>
      </div>
    </template>
  </div>
</template>

<script>

// import FAIcon from 'atom/FAIcon'
import Legend from 'molecule/Legend'
import NeighborhoodControl from 'organism/NeighborhoodControl'
import FilterStatus from 'organism/FilterStatus'
import FilterControl from 'molecule/FilterControl'
import { mapGetters, mapState, mapMutations } from 'vuex'


export default {
  components: {
    // SideMenu, 
    // FontAwesomeIcon,
    Legend,
    NeighborhoodControl,
    FilterControl,
    FilterStatus
  },
  props: {
    menuItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    slim: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buurtTooltip: 'Selecteer de buurt welke je wilt bestuderen. De (socio-economische) buurt informatie, de barcode lijst en de kaart weergaven zullen zich beperken tot deze buurt.',
      filtersTooltip: 'Pas combinaties van filters toe om de dataset te reduceren, om focus aan te brengen op specifieke woning categoriëen. <br/><br/> Een pand wordt uitgesloten zodra deze <i>niet</i> kan voldoen aan 1 of meer van de actieve filter criteria.',
      weergaveTooltip: 'Bepaal hier welke informatie laag op de kaart wordt weergegeven. De legenda past zich automatisch aan. De getallen achter de legenda geven aan hoeveel panden binnen die categorie vallen.',

      selectedFilter: null
    }
  },
  computed: {
    ...mapGetters('version', [
      'version'
    ]),
    ...mapGetters('map', [
      'getLoadedStatus'
    ]),
    ...mapState('sidebar', [
      'filteringOpen', 
      'legendOpen',
      'sidebarInit'
    ]),
    hasLegend() {
      return this.$route.meta.layout === 'map'
    },
    hasBuurtChoice() {
      return this.$route.meta.sidebar !== 'introduction'
    },
    hasFilterControls() {
      return this.$route.meta.layout === 'map'
    },
    hasIntroduction() {
      return this.$route.meta.sidebar === 'introduction'
    },
    hasBarcodeInstructions() {
      return this.$route.meta.sidebar === 'barcode'
    }
  }, 
  mounted() {
    if (this.sidebarInit) {
      this.$nextTick(() => this.checkNeedForToggle({ section: 'legend' }))
    }
  },
  methods: {
    ...mapMutations('sidebar', [
      'setFilteringOpen', 
      'setLegendOpen',
      'sidebarHasInit'
    ]),
    handleSelectedFilter({ filter }) {
      this.selectedFilter = filter
      this.$nextTick(() => this.checkNeedForToggle({ section: 'filtering' }))
    },
    handleClearSelectedFilter() {
      this.selectedFilter = null
    },
    handleToggle({ section }) {
      if (section === 'filtering') {
        this.setFilteringOpen({ status: !this.filteringOpen }) 
      } else {
        this.setLegendOpen({ status: !this.legendOpen })
      }

      if (this.filteringOpen && this.legendOpen) {
        this.$nextTick(() => this.checkNeedForToggle({ section }))
      }
    },
    checkNeedForToggle({ section }) {
      let filterHasScrollbar = null
      if (this.$refs.filterControl || this.$refs.filterStatus) {
        filterHasScrollbar = (this.selectedFilter)  
          ? this.hasScrollBar({ element: this.$refs.filterControl.$el })
          : this.hasScrollBar({ element: this.$refs.filterStatus.$el })
      } else {
        filterHasScrollbar = false
      }  

      if (filterHasScrollbar) {
        if (section === 'filtering') {
          this.setLegendOpen({ status: false })
        } else {
          this.setFilteringOpen({ status: false })
        }
      }
      
      this.sidebarHasInit()
    },
    hasScrollBar({ element }) {
      return (element.scrollHeight > element.offsetHeight)
        || (element.scrollHeight > element.clientHeight)
    }
  }
}
</script>

<style lang="scss">
.SideBar {
  position: relative;
  width: 265px;
  min-width: 265px;
  background: white;
  box-shadow: -1px 0px 0px 0px rgba(223,226,229,1) inset;
  user-select: none;
  color: #7F8FA4;
  // max-height: 100%;
  



  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px auto 50px auto 50px auto 1fr 50px;
  gap: 0px 0px;
  grid-template-areas:
    "Neighborhood_header"
    "Neighborhood"
    "Filters_header"
    "Filters"
    "Legend_header"
    "Legend"
    "Flex"
    "Footer";


  &__neighborhoodHeader { grid-area: Neighborhood_header; }
  &__neighborhood { grid-area: Neighborhood; }
  &__filtersHeader { grid-area: Filters_header; }
  &__filters { grid-area: Filters; }
  &__legendHeader { grid-area: Legend_header; }
  &__legend { grid-area: Legend; }
  &__flex { grid-area: Flex; }
  &__version { grid-area: Footer; }

  &--slim {
    width: 50px;
    min-width: 50px;
    overflow: hidden;
  }

  h5 {
    border-top: 1px solid rgba(0, 0, 0, 0.125);
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    outline: none;
    position: relative;
    cursor: pointer;
    user-select: none;

    &:first-child {
      border-top: none;
      cursor: auto;
    }

    span {
      width: 15px; /** 55px */
      display: inline-block;
    }

    svg {
      position: absolute;
      right: 1.5rem;
      outline: none;
    }
    svg:nth-child(3) {
      right: 4rem;
    }
  }

  &__title {
    height: 60px;
  }
  &__sidemenu {
    flex-grow: 1
  }

  &__legend, &__FilterControl, &__Filters {
    transition: all 0.4s ease-in-out;
    
    &--closed {
      height: 0;
      padding-top: 0 !important;
      padding-bottom: 0 !important;
      overflow-y: scroll;
    }
  }

  ul {
    list-style: none;
  }

  &__version {
    // position: absolute;
    margin-bottom: 1rem;
    padding-left: 1rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(0, 0, 0, 0.125);
  }

  .Filters {
    // position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: white;
    margin-left: -100%;
    transition: margin 0.6s ease-in-out;
    z-index: 9999;
    opacity: 0.99;
    
    &--visible {
      margin-left: 0;
      box-shadow: -1px 0px 0px 0px rgba(223,226,229,1) inset;
    }
  }
}
</style>
